import { byClass, getQueryString, getCurrentPage } from './utils'

function initCube () {
  const cubeEl = byClass('cloudimage-360')
  if (!cubeEl) return
  cubeEl.setAttribute('data-filename', `JM_Cube_${getTwoDigitYear()}_{index}.jpg`)
  window.CI360.init()
}

function getTwoDigitYear() {
  const availableYears = [3, 5, 7, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55]
  let yearCount = getQueryString('year') || 40
  let availableYear = availableYears.find(year => year >= yearCount)
  if (!availableYear) availableYear = availableYears[0]
  return `0${availableYear}`.slice(-2)
}

function getCubeImages() {
  const result = []
  for (let i = 1; i <= 36; i++) {
    result.push(`./cube/JM_Cube_${getTwoDigitYear()}_${`0${i}`.slice(-2)}.jpg`)
  }
  return result
}

function animateCubeVideo() {
  const currentPage = getCurrentPage()
  const videoEl = byClass('keepsake-cubes-video')
  if (!videoEl) {
    return
  }
  if (currentPage === 'keepsake-cubes' || currentPage === 'gifts') {
    videoEl.play()
    videoEl.setAttribute('autoplay', 'autoplay')
    videoEl.setAttribute('controls', 'controls')
  } else {
    videoEl.pause()
    videoEl.removeAttribute('autoplay')
    videoEl.removeAttribute('controls')
  }
}

export {
  initCube,
  animateCubeVideo,
  getCubeImages
}
